var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userEqui == 'pc')?_c('div',{staticStyle:{"width":"100%","height":"900px"}},[_c('div',{staticClass:"MapBox",attrs:{"id":_vm.mapId}})]):_c('div',{style:({ width: this.equiWidth, height: '300px' })},[_c('div',{staticClass:"MapBox",attrs:{"id":_vm.mapId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }